export { default } from './BalancesBlocks';



// WEBPACK FOOTER //
// ./src/components/UserFlowFunds/BalancesBlocks/index.js